// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__3oYXC","btnRed":"styles_btnRed__vB4ti","wrap":"styles_wrap__1UoA7"};